<template>
    <div>
        <v-card :width="isDesktop ? 350 : '100%'" class="ma-auto" flat :outlined="isDesktop" tile>
            <v-container fluid class="signup-container py-5">
                <div class="signup-header py-5" ref="header">
                    <div class="signup-header__logo d-flex justify-center px-6">
                        <router-link to="/" v-ripple>
                            <icon-logo size=150 ref="iconLogo"></icon-logo>
                        </router-link>
                    </div>
                </div>
                <div class="signup-body" style="height: 0; overflow: hidden;" ref="body">
                    <div class="signup-body__content">
                        <h2 class="signup-body__title title grey--text text-center px-6 reveal-item">
                            Sign up to arclif
                        </h2>
                        <div class="px-6 mt-4">
                            <div class="reveal-item">
                                <v-btn block color="blue white--text text-capitalize subtitle-1 text-align-left">
                                    <v-icon dark left>mdi-facebook</v-icon> Login using facebook
                                </v-btn>
                            </div>
                            <div class="reveal-item">
                                <v-btn block color="green white--text text-capitalize subtitle-1 mt-2">
                                    <v-icon dark left>mdi-google</v-icon> Login using gmail
                                </v-btn>
                            </div>
                        </div>
                        <div class="my-8 px-6 reveal-item">
                            <div class="divider grey--text">
                                <span class="divider__text subtitle-2">OR</span>
                            </div>
                        </div>
                        <div class="reveal-item">
                            <form-signup @sendData="manageData"></form-signup>
                        </div>
                        <div class="my-8 px-6 reveal-item">
                            <v-divider></v-divider>
                        </div>
                        <div class="reveal-item">
                            <p class="py-0 px-6 subtitle-2 text-center">
                                Have an account? <router-link to="/account/login/" class="textLinks--text">Log in</router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </v-container>
        </v-card>
    </div>
</template>
<style scoped>
.signup-container {
    display: flex;
    flex-direction: column;
    min-height: 200px;
}

.signup-header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    flex-direction: column;

}

.signup-header__logo,
.signup-header__text {
    max-width: 100%;
}
</style>
<script>
/* eslint-disable */
import signupForm from "@/components/forms/form-signup.vue"
import formMixins from "@/mixins/mixin-animation-form.js"
import {
    SIGN_UP_USER
} from "@/store/actions.type.js"

export default {
    mixins: [formMixins],
    components: {
        'form-signup': signupForm
    },

    mounted() {
        this.$nextTick(() => {
            // Init signup animation if not logedIn
            if (!this.isLogedIn) {
                this.signupEntry()
            }
        })
    },

    beforeRouteLeave(to, from, next) {
        // Body leave and route change
        if (!this.isLogedIn) {
            this.bodyLeave(() => {
                // Go to next route
                next()
            })
        } else {
            next()
        }

    },

    methods: {
        // Manage send event from form
        manageData(formData) {
            // Send request
            this.$store.dispatch(SIGN_UP_USER, formData)
        }
    }
}
</script>